export interface IPreviousAddressesListItem {
  previousAddress: string;
  previousPostcode: string;
  prevCity: string;
  prevState: string;
  prevCountry: string;
  prevFromDate: string;
  prevToDate: string;
}

export interface IPersonalDataStepFormValues {
  title: string;
  surname: string;
  forename: string;
  middleNames: string;
  changedName: string;
  previousSurname: string;
  previousForenames: string;
  gender: string;
  maritalStatus: string;
  identificationDocumentType: string;
  documentType?: string;
  documentNumber: string;
  homeAddress: string;
  postcode: string;
  city: string;
  state: string;
  country: string;
  typeOfResidence: string;
  homePhoneNumber: string;
  mobilePrefix: string;
  mobilePhoneNumber: string;
  email: string;
  height: string;
  placeOfBirth: string;
  dateOfBirth: string;
  nationality: string;
  previousAddresses: string;
  previousAddressesList: IPreviousAddressesListItem[];
  isEmployment: string;
  occupation: string;
  workAddress: string;
  workPostcode: string;
  workCity: string;
  workState: string;
  workCountry: string;
  workPhoneNumber: string;
  workEmail: string;
}
export const initialPersonalDataStepFormValues: IPersonalDataStepFormValues = {
  title: '',
  surname: '',
  forename: '',
  middleNames: '',
  changedName: '0',
  previousSurname: '',
  previousForenames: '',
  gender: '',
  maritalStatus: '',
  identificationDocumentType: '',
  documentType: '',
  documentNumber: '',
  homeAddress: '',
  postcode: '',
  city: '',
  state: '',
  country: '',
  typeOfResidence: '',
  homePhoneNumber: '',
  mobilePrefix: '',
  mobilePhoneNumber: '',
  email: '',
  height: '',
  placeOfBirth: '',
  dateOfBirth: '',
  nationality: '',
  previousAddresses: '0',
  previousAddressesList: [
    {
      previousAddress: '',
      previousPostcode: '',
      prevCity: '',
      prevState: '',
      prevCountry: '',
      prevFromDate: '',
      prevToDate: '',
    },
  ],
  isEmployment: '0',
  occupation: '',
  workAddress: '',
  workPostcode: '',
  workCity: '',
  workState: '',
  workCountry: '',
  workPhoneNumber: '',
  workEmail: '',
};

export interface IPreviousGPListItem {
  doctorName: string;
  doctorAddress: string;
  doctorPostcode: string;
  doctorPhone: string;
  doctorEmail: string;
}

export interface IPersonalHealthStepFormValues {
  beenDiagnosed: string;
  diagnoseDetails: string;
  doctorName: string;
  doctorAddress: string;
  doctorPostcode: string;
  doctorPhone: string;
  doctorEmail: string;
  previousGPList: IPreviousGPListItem[];
  anyPeriodsGP: string;
  periodsAdditionalInfo: string;
  downloadApproved: boolean;
}

export const initialPersonalHealthStepFormValues: IPersonalHealthStepFormValues = {
  beenDiagnosed: '',
  diagnoseDetails: '',
  doctorName: '',
  doctorAddress: '',
  doctorPostcode: '',
  doctorPhone: '',
  doctorEmail: '',

  previousGPList: [
    {
      doctorName: '',
      doctorAddress: '',
      doctorPostcode: '',
      doctorPhone: '',
      doctorEmail: '',
    },
  ],
  anyPeriodsGP: '',
  periodsAdditionalInfo: '',
  downloadApproved: false,
};

export interface IShotgunDetailsStepFormValues {
  holdShotgun: string;
  calibre: string;
  actionType: string;
  make: string;
  serialNumber: string;
  securityArrangements: string;
  securityDetails: string;
  securityType: string;
  securityAdditionalInformation: string;
  certificateHolder: string;
  certificateDetails: string;
  ammoStorage: string;
}

export const initialShotgunDetailsStepFormValues: IShotgunDetailsStepFormValues = {
  holdShotgun: '',
  calibre: '',
  actionType: '',
  make: '',
  serialNumber: '',
  securityArrangements: '',
  securityDetails: '',
  securityType: '',
  securityAdditionalInformation: '',
  certificateHolder: '',
  certificateDetails: '',
  ammoStorage: '',
};

export interface IRefereeDetails {
  refereeTitle: string;
  refereeSurname: string;
  refereeForenames: string;
  refereePreviousNames: string;
  refereeBirthDate: string;
  refereeBirthPlace: string;
  refereeHomeAddress: string;
  refereeHomePostcode: string;
  refereeHomeMobileNumber: string;
  refereeHomeEmail: string;
  refereeOccupation: string;
  refereeWorkMobileNumber: string;
  refereeWorkEmail: string;
  refereeCapacity: string;
  refereeKnown: string;
  refereeGuidanceInformation: string;
}
export interface IRefereeDetailsStepFormValues {
  referee1: IRefereeDetails;
  referee2: IRefereeDetails;
}

export const initialRefereeDetail: IRefereeDetails = {
  refereeTitle: '',
  refereeSurname: '',
  refereeForenames: '',
  refereePreviousNames: '',
  refereeBirthDate: '',
  refereeBirthPlace: '',
  refereeHomeAddress: '',
  refereeHomePostcode: '',
  refereeHomeMobileNumber: '',
  refereeHomeEmail: '',
  refereeOccupation: '',
  refereeWorkMobileNumber: '',
  refereeWorkEmail: '',
  refereeCapacity: '',
  refereeKnown: '',
  refereeGuidanceInformation: '',
};
export const initialRefereeDetailsStepFormValues: IRefereeDetailsStepFormValues = {
  referee1: initialRefereeDetail,
  referee2: initialRefereeDetail,
};
export interface IOffencesListItem {
  offenceDate: string;
  offenceName: string;
}

export interface IOffencesStepFormValues {
  convictedOffence: string;
  offencesList: IOffencesListItem[];
}

export const initialOffencesStepFormValues: IOffencesStepFormValues = {
  convictedOffence: '',
  offencesList: [
    {
      offenceDate: '',
      offenceName: '',
    },
  ],
};

export interface IDeclarationStepFormValues {
  declaration: string;
}

export const initialDeclarationStepFormValues: IDeclarationStepFormValues = {
  declaration: '',
};
